import React, { useState, useEffect, useCallback } from "react";
import AsyncSelect from 'react-select/async';
import moment from "moment";
import Noty from "noty";
import ReactTable from "react-table";
import Modal from "../../componentes/Modal";
import FormPagoComprobante from "../../componentes/Creditos/FormPagoComprobante";
import { decimalAdjust } from "../../Global";
import DetalleDeudaComponent from "../../componentes/Creditos/DetalleDeudaComponent";

const CreditosServicios = () => {
    const [fechaInicio, setFechaInicio] = useState(moment().format('YYYY-MM-DD'));
    const [fechaFin, setFechaFin] = useState(moment().format('YYYY-MM-DD'));
    const [cliente, setCliente] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [deudas, setDeudas] = useState([]);
    const [isOpenPagoModal, setIsOpenPagoModal] = useState(false);
    const [selectedDeuda, setSelectedDeuda] = useState(null);
    const [isOpenDetalleModal, setIsOpenDetalleModal] = useState(false);
    const [totalPagado, setTotalPagado] = useState(0);
    const [totalDeuda, setTotalDeuda] = useState(0);

    const fetchDeudas = useCallback(async () => {
        setIsLoading(true);
        let queryClient = cliente && cliente.value ? `&idCliente=${cliente.value}` : '';
        const query = `fechaInicio=${fechaInicio}&fechaFin=${fechaFin}${queryClient}`;
        
        try {
            const response = await fetch(`/api/creditos/servicios?${query}`);
            const data = await response.json();
            
            const totalD = data.map(x => x.saldo).reduce((a, b) => a + b, 0);
            const totalImportes = data.map(x => x.Total).reduce((a, b) => a + b, 0);
            
            setDeudas(data);
            setTotalDeuda(totalD);
            setTotalPagado(totalImportes - totalD);
        } catch (error) {
            console.error("Error fetching deudas:", error);
            new Noty({
                type: "error",
                theme: "bootstrap-v4",
                layout: "topCenter",
                text: `Error al obtener las deudas`,
                timeout: 1500
            }).show();
        } finally {
            setIsLoading(false);
        }
    }, [fechaInicio, fechaFin, cliente]);

    useEffect(() => {
        // Opcional: Cargar automáticamente al montar el componente
        // fetchDeudas();
    }, []);

    const searchClients = (query) => {
        return new Promise((resolve, reject) => {
            fetch(`/api/clientes/buscar/?query=${query}`)
                .then(r => r.json())
                .then(clientes => {
                    const mappedClientes = clientes.map(c => ({
                        label: `${c.RazonSocial || ""} - ${c.NroTipoDocumento || ""}`,
                        value: c.IdCliente
                    }));
                    resolve(mappedClientes);
                }).catch(reject);
        });
    };

    const buscarDeudas = () => {
        if (fechaInicio && fechaFin) {
            fetchDeudas();
        } else {
            new Noty({
                type: "warning",
                theme: "bootstrap-v4",
                layout: "topCenter",
                text: `Los datos ingresados son inválidos`,
                timeout: 1500
            }).show();
        }
    };

    const onRealizarPagoHandler = (deuda) => {
        setSelectedDeuda(deuda);
        setIsOpenPagoModal(true);
    };

    const onDetallePagosHandler = (deuda) => {
        setSelectedDeuda(deuda);
        setIsOpenDetalleModal(true);
    };

    const onCloseModal = () => {
        setIsOpenPagoModal(false);
        setIsOpenDetalleModal(false);
        fetchDeudas();
    };

    return (
        <section className="ventas-fpay-section pt-5">
            <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2">
                <span className="align-self-center letra-fecha-fpay">
                    Desde:
                </span>

                <input 
                    type="date" 
                    onChange={(e) => setFechaInicio(e.target.value)} 
                    name='fechaInicio' 
                    className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                    value={fechaInicio} 
                />

                <span className="align-self-center letra-fecha-fpay">
                    Hasta:
                </span>

                <input 
                    type="date" 
                    onChange={(e) => setFechaFin(e.target.value)} 
                    name='fechaFin' 
                    className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                    value={fechaFin} 
                />
            </div>

            <div className="container mt-3">
                <div className="caja-fondo-blanco-m-2">
                    <h5 className="sucursal-text-color">
                        Cliente
                    </h5>
                    <div className="col-sm np">
                        <AsyncSelect
                            isClearable={true}
                            defaultOptions={true}
                            onChange={(option) => setCliente(option)}
                            value={cliente}
                            loadOptions={searchClients}
                            placeholder="Buscar cliente..."
                        />
                    </div>
                </div>
                <div className="seccion-btn-verde-mfp">
                    <button 
                        disabled={isLoading} 
                        onClick={buscarDeudas}
                        className="btn btn-outline-primary btn-verde-mfp"
                    >
                        Filtrar
                    </button>
                </div>
            </div>

            <div className="mt-3 container">
                <div className="row">
                    <div className="col-sm-auto">
                        <h4>Total deuda: {decimalAdjust('floor', totalDeuda, -2)}</h4>
                    </div>
                    <div className="col-sm-auto">
                        <h4>Total pagado: {decimalAdjust("floor", totalPagado, -2)}</h4>
                    </div>
                </div>
            </div>

            <div className="mt-3 container no-pad">
                <div className="col-sm-12">
                    <ReactTable
                        loading={isLoading}
                        data={deudas}
                        filterable
                        defaultFilterMethod={(filter, row) =>
                            String(row[filter.id]).toLowerCase().includes(String(filter.value).toLowerCase())
                        }
                        columns={[
                            {
                                columns: [
                                    {
                                        Header: "Código",
                                        id: "IdRegistroVenta",
                                        width: 80,
                                        accessor: d => d.IdRegistroVenta,
                                        filterable: true
                                    },
                                    {
                                        Header: "Razón social",
                                        id: "datos",
                                        width: 180,
                                        accessor: d => d.datos,
                                        filterable: true
                                    },
                                    {
                                        Header: "Serie-Correlativo",
                                        id: "numSerie",
                                        width: 130,
                                        accessor: d => d.numSerie,
                                        filterable: true
                                    },
                                    {
                                        Header: "Importe total",
                                        id: "Total",
                                        width: 100,
                                        filterable: true,
                                        Cell: (d) => decimalAdjust('floor', d.original.Total, -2)
                                    },
                                    {
                                        Header: "Cant. Cuotas",
                                        id: "cantPagos",
                                        width: 100,
                                        accessor: d => d.cantPagos,
                                        filterable: true
                                    },
                                    {
                                        Header: "Saldo",
                                        id: "saldo",
                                        width: 100,
                                        filterable: true,
                                        accessor: d => d.saldo,
                                        Cell: d => decimalAdjust('floor', d.original.saldo, -2)
                                    },
                                    {
                                        Header: "Estado",
                                        id: "estado",
                                        width: 100,
                                        accessor: d => d.estado,
                                        filterable: true
                                    },
                                    {
                                        Header: "Ultima fecha de pago",
                                        id: "ultimaFecha",
                                        width: 100,
                                        accessor: d => d.ultimaFecha,
                                        filterable: true
                                    },
                                    {
                                        Header: "Dias de retraso",
                                        id: "dias_retraso",
                                        width: 100,
                                        accessor: d => d.dias_retraso > 0 ? d.dias_retraso : 0,
                                        filterable: true
                                    },
                                    {
                                        Header: "Acciones",
                                        minwidth: 200,
                                        width: 200,
                                        filterable: false,
                                        Cell: (d) => {
                                            const isAnuladoOrPagado = d.original.estado === "Anulado" || d.original.estado === "Pagado";
                                            return (
                                                <div>
                                                    {!isAnuladoOrPagado && (
                                                        <button 
                                                            onClick={() => onRealizarPagoHandler(d.original)}
                                                            className="btn btn-outline-secondary mr-2"
                                                            disabled={isLoading}
                                                        >
                                                            Realizar pago
                                                        </button>
                                                    )}
                                                    <button 
                                                        className="btn btn-outline-info"
                                                        onClick={() => onDetallePagosHandler(d.original)}
                                                        disabled={isLoading}
                                                    >
                                                        Pagos y NC
                                                    </button>
                                                </div>
                                            );
                                        }
                                    }
                                ]
                            }
                        ]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        previousText='Anterior'
                        nextText='Siguiente'
                        loadingText='Cargando...'
                        noDataText='No se encontraron registros'
                        pageText='Página'
                        ofText='de'
                        rowsText='filas'
                        style={{
                            width: "100%",
                            fontSize: "15px"
                        }}
                        pageSizeOptions={[10, 20, 25, 50, 100]}
                    />
                </div>
            </div>

            <Modal title="Realizar pagos" isOpen={isOpenPagoModal} onClose={onCloseModal}>
                <FormPagoComprobante deuda={selectedDeuda}/>
            </Modal>

            <Modal title="Detalles de pagos y créditos" isOpen={isOpenDetalleModal} onClose={onCloseModal}>
                <DetalleDeudaComponent deuda={selectedDeuda}/>
            </Modal>
        </section>
    );
};

export default CreditosServicios;
